<template>
    <EmployeePendingServiceReports></EmployeePendingServiceReports>
</template>
<script>
    import EmployeePendingServiceReports from '@/components/EmployeePendingServiceReports.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeePendingServiceReports
        }
    }
</script>